"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNT_VERSION_V2 = exports.ACCOUNT_VERSION_V1 = exports.PROGRAM_VERSION = exports.PROGRAM_VERSION_V3 = exports.PROGRAM_VERSION_V2 = exports.PROGRAM_VERSION_V1 = void 0;
exports.PROGRAM_VERSION_V1 = 1;
exports.PROGRAM_VERSION_V2 = 2;
exports.PROGRAM_VERSION_V3 = 3;
// The most up to date program version
exports.PROGRAM_VERSION = exports.PROGRAM_VERSION_V3;
exports.ACCOUNT_VERSION_V1 = 1;
exports.ACCOUNT_VERSION_V2 = 2;
//# sourceMappingURL=constants.js.map